import { useTranslation } from "../../../language";

export default function AddOnSubText() {
  const { t } = useTranslation();
  return <span>{t("addon_subtext")}</span>;
}
